import React from 'react';
import { Scissors } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';

interface LogoProps {
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  subtextClassName?: string;
  variant?: 'light' | 'dark';
  subtext?: string;
  onClick?: () => void;
}

export const Logo: React.FC<LogoProps> = ({ 
  className = '', 
  iconClassName = '',
  textClassName = '',
  subtextClassName = '',
  variant = 'dark',
  subtext,
  onClick 
}) => {
  const { t } = useLanguage();
  
  const isDark = variant === 'dark';
  
  return (
    <button 
      onClick={onClick}
      aria-label="Sharp Cuts Home"
      className={`flex items-center gap-3 md:gap-4 transition-all duration-300 group ${onClick ? 'hover:opacity-80 cursor-pointer' : 'cursor-default'} ${className}`}
      disabled={!onClick}
    >
      <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl md:rounded-2xl flex items-center justify-center shadow-xl transition-transform duration-500 group-hover:rotate-0 rotate-[-4deg] ${
        isDark ? 'bg-zinc-900 shadow-zinc-200' : 'bg-white shadow-black/20'
      } ${iconClassName}`}>
        <Scissors className={isDark ? 'text-white' : 'text-zinc-900'} size={20} aria-hidden="true" />
      </div>
      <div className="text-left">
        <h1 className={`text-lg md:text-xl font-black uppercase tracking-tighter leading-none ${
          isDark ? 'text-zinc-900' : 'text-white'
        } ${textClassName}`}>
          Sharp Cuts
        </h1>
        <p className={`text-[10px] font-bold uppercase tracking-widest mt-1 whitespace-nowrap ${
          isDark ? 'text-zinc-400' : 'text-zinc-300'
        } ${subtextClassName}`}>
          {subtext || 'Premium Barbering'}
        </p>
      </div>
    </button>
  );
};
